import { ItemInfoDialog } from '@colonist/clientforge';
import { clientI18n } from '../ClientI18n.ts';
import { getLobbyImagePath } from '../ui_utils/Utils.ts';
import { mountDialogUIReactComponent } from '../ui_platform/mountDialogUIReactComponent.tsx';
const renderItemInfoDialog = mountDialogUIReactComponent(ItemInfoDialog);
export function showRoomItemInfoDialog(options) {
    let description = '';
    if (options.bodyItems != undefined) {
        const items = clientI18n.tArray(options.bodyItems);
        description = '<ul>' + items.map((item)=>`<li>${item}</li>`).join('') + '</ul>';
    } else {
        description = options.bodyText;
    }
    renderItemInfoDialog({
        title: options.title,
        imageUrl: getLobbyImagePath(options.image),
        description: description,
        onSubscribe: options.onSubscribe
    });
}
